import { CircularProgress, Stack, Typography } from '@mui/material';

import { useLocalization } from 'localization';
import CreateOrder from './CreateNewOrder';
import ErrorPage from 'components/v2/shared/ErrorPage';
import { useCreateOrderRedirectFlow } from 'hooks/services/useCreateOrderRedirectFlow';

const CreateOrderRedirectFlow = () => {
  const { t } = useLocalization();
  const { apiState, data } = useCreateOrderRedirectFlow();
  const { foundCase, doesCurrentUserHaveAccess, user } = data;

  if (apiState.loading) {
    return (
      <Stack width="100%" height="100%" justifyContent="center" alignItems="center">
        <CircularProgress size={50} />
      </Stack>
    );
  }

  if (!doesCurrentUserHaveAccess || !foundCase) {
    return (
      <ErrorPage
        doesCurrentUserHaveAccess={doesCurrentUserHaveAccess}
        user={user}
        foundCase={foundCase}
        source="new-order-for-case"
      />
    );
  }

  if (foundCase.isArchived) {
    return (
      <ErrorPage
        doesCurrentUserHaveAccess={doesCurrentUserHaveAccess}
        user={user}
        foundCase={foundCase}
        contentChild={
          <Stack justifyContent="center" alignItems="center">
            <Typography variant="h4">{t('orders.pages.new.flowSelection.archivedMaterials')}</Typography>
          </Stack>
        }
        source="new-order-for-case"
      />
    );
  }

  return <CreateOrder />;
};

export default CreateOrderRedirectFlow;
